import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {useFormik, FormikContext} from "formik";
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { setGetGameFreespin } from '../../store/thunk/setGetGameFreespin';
import { setPostCreateFs } from '../../store/thunk/setPostCreateFs';

const useStyles = makeStyles(() => ({
    btn: {
        cursor: 'pointer',
        marginRight: '8px',
        minWidth: '84px',
        color: '#fff',
        backgroundColor: '#6c757d',
        borderColor: '#6c757d',
        display: 'inline-flex',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '.375rem .75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '.25rem',
        transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        '&:hover': {
            color: '#fff',
            backgroundColor: '#5a6268',
            borderColor: '#545b62',
        }
    },
    btn2: {
        cursor: 'pointer',
        height: '50px',
        width: 300,
        color: '#fff',
        backgroundColor: '#007bff',
        borderColor: '#007bff',
        fontWeight: 700,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '.25rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        '&:hover': {
            color: '#fff',
            backgroundColor: '#0069d9',
            borderColor: '#0062cc',
        }
    },
    inp: {
        height: '40px',
        maxWidth: '252px',
        outline: 'none',
        display: 'block',
        width: '100%',
        padding: '.375rem .75rem',
        fontSize: 18,
        lineHeight: 1.5,
        color: '#495057',
        backgroundColor: '#fff',
        backgroundClip: 'padding-box',
        border: '1px solid #ced4da',
        borderRadius: '.25rem',
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        marginRight: 12
    },
    wrapCol: {
        display: 'flex', 
        flexDirection: 'column', 
        border: '1px solid #e3e3e3',
        marginBottom: 8
    },
    spanCol: {

        paddingLeft: 5,
        lineHeight: 1.42857143,
        verticalAlign: 'top',
        fontSize: '21px',
        fontWeight: 400,
    },
    bb: {
        borderBottom: '1px solid #e3e3e3',
    },
    btn3: {
        height: '50px',
        width: 300,
        color: '#fff',
        fontWeight: 700,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '.25rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        background: '#e5e5e5', 
        borderColor: '#e5e5e5', 
        cursor: 'default'
    }
}));

const FsModal = ({fs, setFs, id, profile}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetGameFreespin({
            currency: profile?.currency
        }));
        // eslint-disable-next-line
    }, [])

    const initialValues = {

    }

    const onSubmit = (store) => {
        store.id = id;
        dispatch(setPostCreateFs(store, setFs))
        formik.resetForm();
    }
    const games = useSelector((state) => state.users.games);

    const formik = useFormik({onSubmit, initialValues});
    return (
        <Dialog onClose={() => setFs(false)} open={fs}>
            <FormikContext.Provider value={formik}>
                <form onSubmit={formik.handleSubmit} >
                    <div style={{
                        padding: '11px 14px',
                        borderRadius: 4,
                        backgroundColor: '#dff0d8',
                        border: '1px solid #d0e9c6',
                    }}>
                        <div>
                            <label htmlFor="currency">
                                <span>Валюта</span>
                                <input 
                                    type="text"
                                    style={{width: 'calc(100% - 40px)', padding: 10, outline: 'none', border: '1px solid #eee', borderRadius: 4}} 
                                    value={profile?.currency}
                                    disabled={true}
                                />
                            </label>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <h3>Выдача фриспинов</h3>
                            </div> 
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div style={{display: 'flex'}}>
                                    <span 
                                        onClick={() => formik.setFieldValue('fsCount', 25)}
                                        style={{marginRight: 12, padding: 10, border: formik.values.fsCount === 25 ? '1px solid #007bff' : '1px solid #e5e5e5', background: '#fff', borderRadius: 4, cursor: 'pointer'}}
                                    >25</span>
                                    <span 
                                        onClick={() => formik.setFieldValue('fsCount', 30)}
                                        style={{marginRight: 12, padding: 10, border: formik.values.fsCount === 30 ? '1px solid #007bff' : '1px solid #e5e5e5', background: '#fff', borderRadius: 4, cursor: 'pointer'}}
                                    >30</span>
                                    <span 
                                        onClick={() => formik.setFieldValue('fsCount', 50)}
                                        style={{marginRight: 12, padding: 10, border: formik.values.fsCount === 50 ? '1px solid #007bff' : '1px solid #e5e5e5', background: '#fff', borderRadius: 4, cursor: 'pointer'}}
                                    >50</span>
                                    <span 
                                        onClick={() => formik.setFieldValue('fsCount', 75)}
                                        style={{marginRight: 12, padding: 10, border: formik.values.fsCount === 75 ? '1px solid #007bff' : '1px solid #e5e5e5', background: '#fff', borderRadius: 4, cursor: 'pointer'}}
                                    >75</span>
                                    <span 
                                        onClick={() => formik.setFieldValue('fsCount', 100)}
                                        style={{marginRight: 12, padding: 10, border: formik.values.fsCount === 100 ? '1px solid #007bff' : '1px solid #e5e5e5', background: '#fff', borderRadius: 4, cursor: 'pointer'}}
                                    >100</span>
                                    <span 
                                        onClick={() => formik.setFieldValue('fsCount', 150)}
                                        style={{marginRight: 12, padding: 10, border: formik.values.fsCount === 150 ? '1px solid #007bff' : '1px solid #e5e5e5', background: '#fff', borderRadius: 4, cursor: 'pointer'}}
                                    >150</span>
                                </div>
                            </div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', width: 300, marginTop: 20, marginBottom: 20}}>
                            <span>Выбрать игру: </span>
                            <div style={{background: '#fff', padding: 10, borderRadius: 8, height: 200, overflowY: 'scroll'}}>
                                {
                                    games.map(item => {
                                        return (
                                            <div 
                                                onClick={() => {
                                                    formik.setFieldValue('game', item)
                                                }}
                                                style={{height: 30, display: 'flex', alignItems: 'center', background: formik.values.game?.id === item.id && '#0069d9', color:  formik.values.game?.id === item.id && '#fff', cursor: 'pointer', borderRadius: 8, padding: '0 10px'}}>
                                                <span>{item.name}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <span className={clsx((!formik.values.game?.uuid || !formik.values.fsCount) ? classes.btn3 : classes.btn2)} 
                                onClick={() => {
                                    if (!(!formik.values.game?.uuid || !formik.values.fsCount)) {
                                        formik.setFieldValue('type', 'freespin');
                                        formik.submitForm()
                                    }
                                }}>Выдать</span>
                    </div>
                        
                    </form>
            </FormikContext.Provider>
            
        </Dialog>
    )
}

export default FsModal;